import React from 'react'
import { useRouter } from 'next/router'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// resources
import PreviewImage from 'assets/images/studio-preview-image-user.png'

// styles
import styles from './index.module.scss'

const TrendingBrandCardMobile = ({ data }) => {
  const router = useRouter()

  const handleShopButton = e => {
    if (data?.creatorUsername) {
      router.push(`/${data.creatorUsername}/merch`)
    }
  }

  // Extract banner image, profile picture, store name, description, and products
  const storeImage = data?.creatorStoreUrl?.length > 0 ? data.creatorStoreUrl : PreviewImage.src
  const description =
    data?.description ||
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'

  return (
    <div className={styles.container}>
      <div className="w-full h-[95px]">
        <ImageWithFoster src={storeImage} className="w-full h-full overflow-hidden object-cover" />
      </div>
      <div className="w-full px-[16px] py-[13px]">
        <div className="w-full flex justify-between items-center">
          <div className={styles.title}>{data?.name}</div>
          <div className={styles.shopButton} onClick={handleShopButton}>
            Shop
          </div>
        </div>
        <div className="w-full mt-[8px]">
          <div className={styles.description}>{description}</div>
        </div>
      </div>
    </div>
  )
}

export default TrendingBrandCardMobile
